import SortIndicator from "../icons/sort-indicator/SortIndicator";
import { FilterBuilderProps } from "./HeaderCellRenderer.types";

const HeaderCellRenderer = ({
  dataIndex,
  titleText,
  inputFilter,
  getSortOrder: fnSortOrder,
  onClick,
}: FilterBuilderProps) => {
  return (
    <>
      <table>
        <tbody>
          <tr>
            <td className="flex w-full place-content-between min-w-[9rem]">
              <span className="text-nowrap truncate font-semibold">
                {titleText}
              </span>
              <span className="w-auto" onClick={onClick}>
                {dataIndex ? (
                  <SortIndicator sortOrder={fnSortOrder()} />
                ) : (
                  <>&nbsp;</>
                )}
              </span>
            </td>
          </tr>
          <tr>
            <td>{inputFilter ? inputFilter : <>&nbsp;</>}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default HeaderCellRenderer;
